import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {getPlaceNameAll, getPlaceNameHistory, getUsers, updateStartend} from '../../../services/MadricService';
import {useNavigate} from 'react-router';
import CheckinInfoView from './CheckinInfoView';
import {deleteStartEnd} from '../../../services/MadricService';
import dayjs from 'dayjs';
import swal from 'sweetalert';
import Spinner from '../../Spinner/Spinner';

/**
 * LEs info d'un checkin pour le modifier
 * @return {JSX}
 */
function CheckinInfo() {
  const navigate = useNavigate();

  // Permet de recevoir par parametre toutes les information du checkin pour préremplir le checkin, recu de la liste de checkin
  const location = useLocation();
  const {startend} = location.state;
  // Liste de taches pour le graphique
  const [taches, setTaches] = useState([{}]);

  const [nbHeures, setNbHeures] = useState(0);

  // Form a update pour le checkin
  const [form, setForm] = useState({note: startend.note,
    date: startend.date,
    checkin: startend.from === null ? null : dayjs(startend.from, 'HH:mm'),
    checkout: startend.to === null ? null : dayjs(startend.to, 'HH:mm'),
    transport: startend.transport,
    employer: startend.work_with,
    extra1: startend.extra1,
    extra2: startend.extra2,
    extra3: startend.extra3,
    chantier: {
      value: startend.place_id,
      label: startend.place,
    },
  });

  // Permet de savoir s'il faut la liste complete de chantier ou juste les 15 dernier
  const [checkedChantier, setCheckedChantier] = useState(false);
  let checkedChantierAfterRender = false;

  // liste de chantiers
  const [placeName, setPlaceName] = useState([]);

  // liste d'employers
  const [usernames, setusernames] = useState([{}]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (startend.from != null && startend.to != null) {
      const [hours1, minutes1] = startend.from.split(':');
      const [hours2, minutes2] = startend.to.split(':');

      setNbHeures((parseInt(hours2, 10) * 60 + parseInt(minutes2, 10)) - (parseInt(hours1, 10) * 60 + parseInt(minutes1, 10)));
    }
    listUsername();
    fetchPlaces();
  }, []);

  /**
  * Permet d'allez chercher la liste des chantiers
  */
  async function fetchPlaces() {
    if (checkedChantierAfterRender) {
      const res = await getPlaceNameAll();
      setPlaceName(res);
    } else {
      const res = await getPlaceNameHistory();
      setPlaceName(res);
    }
  }

  /**
   * Permet de supprimer un checkin
   */
  async function handleDelete() {
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer ce checkin',
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });
            setIsLoading(true);
            await deleteStartEnd(startend.id);
            setIsLoading(false);
            navigate('/Checkin');
          } else {
            swal('Annulé!');
          }
        });
  }

  /**
   * Permet d'allez chercher la liste des users
   */
  async function listUsername() {
    const res = await getUsers();
    setusernames(res);
  }

  // Les prochaines fonctions permettent d'update le form onChange
  const handleChantierCheckBox = () => {
    setCheckedChantier((prevState) => !prevState);
    checkedChantierAfterRender = !checkedChantier;
    fetchPlaces();
  };

  const handleChangeCheckBox = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };

  const handleChange = (event, formValue) => {
    setForm({
      ...form,
      [formValue]: event,
    });

    if (formValue === 'checkin' && form.checkout != null) {
      setNbHeures((parseInt(form.checkout.$H, 10) * 60 + parseInt(form.checkout.$m, 10)) - (parseInt(event.$H, 10) * 60 + parseInt(event.$m, 10)));
    }

    if (formValue === 'checkout' && form.checkin != null) {
      setNbHeures((parseInt(event.$H, 10) * 60 + parseInt(event.$m, 10)) - (parseInt(form.checkin.$H, 10) * 60 + parseInt(form.checkin.$m, 10)));
    }
  };

  const handleNoteChange = (event) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        note: event.target.value,
      };
    });
  };

  const handleDateChange = (event) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        date: event.target.value,
      };
    });
  };


  const handleCheckoutChange = (timeValue) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        checkout: timeValue,
      };
    });

    if (form.checkin != null) {
      setNbHeures((parseInt(timeValue.$H, 10) * 60 + parseInt(timeValue.$m, 10)) - (parseInt(form.checkin.$H, 10) * 60 + parseInt(form.checkin.$m, 10)));
    }
  };

  const handleEmployeeChange = (event) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        employer: event,
      };
    });
  };


  /**
   * Permet d'envoyer le formulaire
   * @param {*} event event
   */
  async function handleSubmit(event) {
    event.preventDefault();

    const errorsForm = {};

    setForm((prevData) => ({
      ...prevData,
      errorsForm,
    }));

    if (form.checkout !== null && form.checkin !== null && form.checkout < form.checkin) {
      errorsForm.heure = 'Le checkout le peut pas être plus petit que le checkin.';
    };


    if (Object.keys(form.chantier).length === 0) {
      errorsForm.chantier = 'Le chantier ne peut pas être vide.';
    };

    const currentDate = new Date();

    const currentDayOfWeek = currentDate.getDay();
    const daysToSubtract = currentDayOfWeek + 1;
    const lastSunday = new Date();
    lastSunday.setDate(currentDate.getDate() - daysToSubtract - 7);
    const inputDate = new Date(form.date);

    if (inputDate <= lastSunday || inputDate > currentDate) {
      errorsForm.date = 'La date doit être entre dimanche de la semaine passée et aujourd\'hui';
    };

    if (Object.keys(errorsForm).length > 0) {
      setForm((prevData) => ({
        ...prevData,
        errorsForm,
      }));
    } else {
      let tacheslist;

      if (taches.length === 0 || taches === null || taches === undefined) {
        tacheslist = null;
      } else if (Object.keys(taches[0]).length === 0) {
        tacheslist = null;
      } else {
        tacheslist = taches;
      };

      form.checkin = form.checkin === null ? null : form.checkin.$H + ':' + form.checkin.$m;
      form.checkout = form.checkout === null? null : form.checkout.$H + ':' + form.checkout.$m;
      setIsLoading(true);
      await updateStartend(startend.id, form, tacheslist);
      setIsLoading(false);
      navigate('/checkin');
    }
  };

  /**
   * Permet de revenir en arrière
   */
  function back() {
    const week = location.state.week;
    navigate('/Checkin', {state: {week}});
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <CheckinInfoView
        handleNoteChange={handleNoteChange}
        handleDateChange={handleDateChange}
        handleEmployeeChange={handleEmployeeChange}
        handleCheckoutChange={handleCheckoutChange}
        handleSubmit={handleSubmit}
        form={form}
        handleChantierCheckBox={handleChantierCheckBox}
        placeName={placeName}
        startend={startend}
        taches={taches}
        setTaches={setTaches}
        usernames={usernames}
        nbHeures={nbHeures}
        handleDelete={handleDelete}
        handleChangeCheckBox={handleChangeCheckBox}
        handleChange={handleChange}
        back={back} />
    </React.Fragment>
  );
}

export default CheckinInfo;
